/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import { AccommodationTaxState } from '../state/AccommodationTaxState'
import MonthlyReportEvent from '../../event/MonthlyReportEvent'

class AccommodationTaxesStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyReportEvent.accommodationTaxMonthChanged:
        if (!payload || !payload.accommodation_tax) {
          return state
        }

        const taxes = payload.accommodation_tax.map(tax => new AccommodationTaxState(tax))
        return List(taxes)
      default:
        return state
    }
  }
}

export default new AccommodationTaxesStore()
